<ng-container [ngSwitch]="status">
	<div *ngSwitchCase="'messaging/permission-blocked'" class="d-flex justify-content-center kp-message kp-message-warning my-2" (click)="blockedModal.open()">
		<div class="d-inline-flex" >
			<div class="">
				<i class="fa fa-exclamation-triangle fs-xxl f-red fw-bold"></i>
			</div>
			<div class="px-1 text-justify m-1">
				<div class="fs-normal fs-md-xl f-red fw-bold">توجه: شما دریافت پیام‌ها را در مرورگر فعال نکرده‌اید</div>
				<div>
					برای دریافت روزانه آگهی‌ها باید دریافت پیام‌ها را در مرورگر فعال کنید.
				</div>
				<div class="">لطفا جهت فعالسازی، تنظیمات دریافتِ «اطلاعیه(Notification)» را از وضعیت «مسدود(Blocked)»
					به
					«تایید(Allow)» تغییر دهید
					<i class="fa fa-question-circle fs-xl f-blue d-md-none"></i>
				</div>
			</div>
			<div class=" text-left d-none d-md-block">
				<i class="fa fa-question-circle fs-xxl f-blue"></i>
			</div>
		</div>
	</div>

	<div *ngSwitchCase="'messaging/permission-default'" class="d-flex justify-content-center kp-message kp-message-warning my-2">
		<div class="d-inline-flex" (click)="requestPermission()">
			<div class="">
				<i class="fa fa-exclamation-triangle fs-xxl f-yellow"></i>
			</div>
			<div class="px-1 text-justify m-1">
				<div class="fs-normal fs-md-xl f-red fw-bold">توجه: شما دریافت پیام‌ها را در مرورگر فعال نکرده‌اید</div>
				<div>
					برای دریافت روزانه آگهی‌ها باید دریافت پیام‌ها را در مرورگر فعال کنید.
				</div>

				<div class="">لطفا جهت فعالسازی کلیک و سپس دریافتِ «اطلاعیه(Notification)» را «تایید(Allow)» کنید.
					<i class="fa fa-bell fs-xl f-blue d-md-none"></i>
				</div>
			</div>
			<div class=" text-left d-none d-md-block">
				<i class="fa fa-bell fs-xxl f-blue"></i>
			</div>
		</div>
	</div>
	<div *ngSwitchCase="'messaging/permission-checking'" class="d-flex justify-content-center kp-message kp-message-warning my-2 relative">
		<ngx-spinner size="small" [fullScreen]="false" type="timer" name="push-checking"></ngx-spinner>
		<div class="d-inline-flex">
			<div class="">
				<i class="fa fa-exclamation-triangle fs-xxl f-yellow"></i>
			</div>
			<div class="px-1 text-justify m-1">
				<div class="fs-normal fs-md-xl">&nbsp;</div>
				<div>
					برای دریافت روزانه آگهی‌ها باید دریافت پیام‌ها را در مرورگر فعال کنید.
				</div>
				<div class="">لطفا جهت فعالسازی کلیک و سپس دریافتِ «اطلاعیه(Notification)» را «تایید(Allow)» کنید.
					<i class="fa fa-bell fs-xl f-blue d-md-none"></i>
				</div>
			</div>
			<div class=" text-left d-none d-md-block">
				<i class="fa fa-bell fs-xxl f-blue"></i>
			</div>
		</div>
	</div>
	<div *ngSwitchCase="'messaging/permission-allowed'" class="d-flex justify-content-center kp-message kp-message-warning my-2">
		<div class="d-inline-flex"
			(click)="openNotificationPanel()">
			<div class="">
				<i class="fa fa-exclamation-triangle fs-xxl"></i>
			</div>
			<div class="px-1 text-justify m-1">
				<div class="fs-normal fs-md-xl f-red fw-bold">شما پیام مشاهده نشده دارید!</div>
				<div class="fs-sm">این پیام‌ها در نوار وضعیت دستگاه شما نمایش داده می‌شود.
					با کلیک روی هر پیام جزئیات آن را مشاهده کنید
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ngx-smart-modal #blockedModal identifier="blockedModal">
	<div class="kp-message kp-message-warning">
		برای خارج شدن از حالت بلاک، باید روی قفل کوچک (<i class="fa fa-lock"></i>) بالای صفحه بزنید و
		«اطلاعیه(Notification)»
		را فعال کنید.
	</div>
	<div class="kp-card">در صورت نیاز به راهنمایی بر روی این آیکون واتس‌آپ پشتیبانی
		<app-whatsapp-message class="mr-3 fs-xxl" [mobile]="2128429921" text="سلام.
دریافت اطلاعیه بر روی دستگاه من غیرفعال است.
برای فعالسازی نیاز به راهنمایی دارم."></app-whatsapp-message>&nbsp;
		کلیک کنید.
	</div>
</ngx-smart-modal>